"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBorrowCore = exports.buildStakingAccrualContract = exports.createContractsFromWallets = exports.createContracts = void 0;
const typings_1 = require("@arcxgame/contracts/dist/src/typings");
const __1 = require("../..");
// Deliberately not making this dynamic, easier readability - Classicus
function createContracts(chains, providerMapping) {
    return {
        passportScores: {
            1: buildPassportScoreContract('1', chains[1], providerMapping[1]),
            4: buildPassportScoreContract('4', chains[4], providerMapping[4]),
            137: buildPassportScoreContract('137', chains[137], providerMapping[137]),
            80001: buildPassportScoreContract('80001', chains[80001], providerMapping[80001]),
        },
        defiPassports: {
            1: buildDefiPassportContract('1', chains[1], providerMapping[1]),
            4: buildDefiPassportContract('4', chains[4], providerMapping[4]),
            80001: buildDefiPassportContract('80001', chains[80001], providerMapping[80001]),
        },
        defaultSkins: {
            1: buildDefaultSkinContract('1', chains[1], providerMapping[1]),
            4: buildDefaultSkinContract('4', chains[4], providerMapping[4]),
            80001: buildDefaultSkinContract('80001', chains[80001], providerMapping[80001]),
        },
        stakingAccrual: {
            1: buildStakingAccrualContract('1', chains[1], providerMapping[1]),
            4: buildStakingAccrualContract('4', chains[4], providerMapping[4]),
        },
        borrowCore: {
            80001: buildBorrowCore('80001', chains[80001], providerMapping[80001]),
        },
    };
}
exports.createContracts = createContracts;
function buildPassportScoreContract(chainId, chainConfig, provider) {
    const contract = (0, __1.loadContract)({ network: chainId, name: 'SapphirePassportScoresProxy' });
    return {
        contract: typings_1.SapphirePassportScoresFactory.connect(contract.address, provider),
        contractCreationTx: contract.txn,
        address: contract.address,
        chainId,
        isTestNetwork: chainConfig.isTestNetwork,
        network: (0, __1.castToNetwork)(chainConfig.network),
    };
}
function buildDefiPassportContract(chainId, chainConfig, provider) {
    const contract = (0, __1.loadContract)({ network: chainId, name: 'DefiPassportProxy' });
    return {
        contract: typings_1.DefiPassportFactory.connect(contract.address, provider),
        contractCreationTx: contract.txn,
        address: contract.address,
        chainId,
        isTestNetwork: chainConfig.isTestNetwork,
        network: (0, __1.castToNetwork)(chainConfig.network),
    };
}
function buildDefaultSkinContract(chainId, chainConfig, provider) {
    const contract = (0, __1.loadContract)({ network: chainId, name: 'DefaultPassportSkin' });
    return {
        contract: typings_1.DefaultPassportSkinFactory.connect(contract.address, provider),
        contractCreationTx: contract.txn,
        address: contract.address,
        chainId,
        isTestNetwork: chainConfig.isTestNetwork,
        network: (0, __1.castToNetwork)(chainConfig.network),
    };
}
function buildPassportScoreContractFromWallet(chainId, chainConfig, wallet) {
    const contract = (0, __1.loadContract)({ network: chainId, name: 'SapphirePassportScoresProxy' });
    return {
        contract: typings_1.SapphirePassportScoresFactory.connect(contract.address, wallet),
        contractCreationTx: contract.txn,
        address: contract.address,
        chainId,
        isTestNetwork: chainConfig.isTestNetwork,
        network: (0, __1.castToNetwork)(chainConfig.network),
    };
}
function createContractsFromWallets(chainConfig, walletMap) {
    return {
        passportScores: {
            1: buildPassportScoreContractFromWallet('1', chainConfig[1], walletMap[1]),
            4: buildPassportScoreContractFromWallet('4', chainConfig[4], walletMap[4]),
            137: buildPassportScoreContractFromWallet('137', chainConfig[137], walletMap[137]),
            80001: buildPassportScoreContractFromWallet('80001', chainConfig[80001], walletMap[80001]),
        },
    };
}
exports.createContractsFromWallets = createContractsFromWallets;
function buildStakingAccrualContract(chainId, chainConfig, provider) {
    const contract = (0, __1.loadContract)({ network: chainId, name: 'StakingAccrualERC20Proxy' });
    return {
        contract: typings_1.StakingAccrualERC20Factory.connect(contract.address, provider),
        contractCreationTx: contract.txn,
        address: contract.address,
        chainId,
        isTestNetwork: chainConfig.isTestNetwork,
        network: (0, __1.castToNetwork)(chainConfig.network),
    };
}
exports.buildStakingAccrualContract = buildStakingAccrualContract;
function buildBorrowCore(chainId, chainConfig, provider) {
    const contract = (0, __1.loadContract)({
        network: chainId,
        name: 'SapphireCoreProxy',
        type: 'borrowing',
    });
    return {
        contract: typings_1.SapphireCoreV1Factory.connect(contract.address, provider),
        contractCreationTx: contract.txn,
        address: contract.address,
        chainId,
        isTestNetwork: chainConfig.isTestNetwork,
        network: (0, __1.castToNetwork)(chainConfig.network),
    };
}
exports.buildBorrowCore = buildBorrowCore;
//# sourceMappingURL=index.js.map